"use strict";

// переводим только строки, которые относятся к неиспользуемому у нас функционалу
// остальные ключи оставляем дефолтными
$.Redactor.opts.langs[$("html").attr("lang")] = $.extend({}, $.Redactor.opts.langs["en"], {
    "formatting": t("photobook-tooltipText-textFormatting"),
    "paragraph": t("photobook-tooltipText-paragraph"),
    "header1": t("photobook-tooltipText-header1"),
    "header2": t("photobook-tooltipText-header2"),
    "header3": t("photobook-tooltipText-header3"),
    "header4": t("photobook-tooltipText-header4"),
    "header5": t("photobook-tooltipText-header5"),
    "bold":  t("photobook-tooltipText-bold"),
    "italic": t("photobook-tooltipText-italic"),
    "fontcolor": t("photobook-tooltipText-forecolor"),
    "backcolor": t("photobook-tooltipText-bgcolor"),
    "unorderedlist": t("photobook-tooltipText-unorderedlist"),
    "orderedlist": t("photobook-tooltipText-orderedlist"),
    "cancel": t("photobook-js-buttonsCancel"),
    "save": t("photobook-js-buttonsSave"),
    "_delete": t("photobook-js-buttonsDelete"),
    "align_left": t("photobook-tooltipText-alignleft"),
    "align_center": t("photobook-tooltipText-aligncenter"),
    "align_right": t("photobook-tooltipText-alignright"),
    "align_justify": t("photobook-tooltipText-alignjustify"),
    "underline": t("photobook-tooltipText-underline"),
    "alignment": t("photobook-tooltipText-alignment"),

    "fontfamily": t("photobook-tooltipText-fontfamily"),
    "fontsize": t("photobook-tooltipText-fontsize"),
});
